import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { DetalleComponent } from './pages/detalle/detalle.component';
import { PrioryResolve } from './core/resolve/priory.resolve';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        resolve:{ userposts: PrioryResolve },
    },
    {
        path: 'detalle',
        component: DetalleComponent,
        resolve:{ userposts: PrioryResolve },
    },
    {
        path: 'gracias',
        component: DetalleComponent,
        resolve:{ userposts: PrioryResolve },
    },
];
